<template>
  <span>
    <Header style="height:40px;" :parameters="'client'" :window="window" />
    <div
      class="textit_background_home has-text-centered"
      :style="this.background"
    >
      <div style="padding-top:50px;margin:0px auto;max-width:360px;">
        <div class="card" style="padding:20px;">
          <div v-if="programmed.affichage">
            <p style="font-weight:bold">{{ programmed.name }}</p>
            {{ $t("client.programme.du") }}
            {{
              programmed.dateDebut
                .substring(0, 10)
                .split("-")
                .reverse()
                .join("/")
            }}
            {{ $t("client.programme.au") }}
            {{
              programmed.dateFin
                .substring(0, 10)
                .split("-")
                .reverse()
                .join("/")
            }}
          </div>
          <div v-else>
            <div class="control has-text-centered">
              <!-- email -->
              <b-field>
                <b-input
                  icon-pack="fas"
                  icon="envelope"
                  type="email"
                  v-model="email"
                  maxlength="70"
                  :has-counter="false"
                  :placeholder="$t('public.email')"
                  required
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,20}"
                />
              </b-field>
              <!-- firstname -->
              <b-field>
                <b-input
                  icon-pack="fas"
                  icon="user"
                  type="text"
                  maxlength="40"
                  :has-counter="false"
                  required
                  v-model="firstname"
                  :placeholder="$t('public.firstname')"
                />
              </b-field>
              <!-- lastname -->
              <b-field>
                <b-input
                  icon-pack="fas"
                  icon="user"
                  type="text"
                  maxlength="40"
                  :has-counter="false"
                  required
                  v-model="lastname"
                  :placeholder="$t('public.lastname')"
                />
              </b-field>
              <!-- phone -->
              <b-field>
                <b-input
                  icon-pack="fas"
                  icon="phone"
                  type="tel"
                  maxlength="10"
                  :has-counter="false"
                  v-model="telephone"
                  :placeholder="$t('public.telephone')"
                  pattern="^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,5})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$"
                />
              </b-field>
              <!-- CGU -->
              <div class="field">
                <b-checkbox size="is-small" v-model="cgu"></b-checkbox>
                <a style="font-size:12px;" @click="confirmCGU">{{
                  $t("public.cgu")
                }}</a>
              </div>
              <button
                class="button"
                :disabled="isDisabled"
                @click="ParticiperInsight"
              >
                {{ $t("button.connecter") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer :parameters="'client'" :window="window" />
  </span>
</template>

<script>
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import axios from "axios";

export default {
  data() {
    return {
      cgu: false,
      firstname: "",
      lastname: "",
      telephone: "",
      email: "",
      insight_name: "",
      insight_id: "",
      background: "",
      url_insight: process.env.VUE_APP_URL_MEDIA,
      urlparticipant: this.$route.params.urlparticipant,
      errors: [],
      window: {
        width: window.innerWidth,
      },
      programmed: false,
    };
  },
  components: {
    Header,
    Footer,
  },
  computed: {
    isDisabled() {
      if (
        !this.cgu ||
        !verifMail(this.email) ||
        !this.lastname ||
        !this.firstname
      )
        return true;
      else return false;
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      let message = {
        height: document.body.scrollHeight,
      };
      window.top.postMessage(message, "*");
      this.window.width = window.innerWidth;
    },
    ParticiperInsight() {
      const form_values = new FormData();
      form_values.append("email", this.email);
      form_values.append("firstname", this.firstname);
      form_values.append("lastname", this.lastname);
      form_values.append("telephone", this.telephone);
      axios.defaults.headers.common["urlparticipant"] = this.urlparticipant;
      axios
        .post(
          process.env.VUE_APP_URL_SSO_API + "insight/inscription",
          form_values
        )
        .then((response) => {
          // le gars est inconnu sur ce test, il commence une nouvelle session
          if (response.data.message == "nouveau") {
            this.$store.commit("NEW_PARTICIPANT", response.data.infos);
            this.$store.commit("INSIGHT_QUESTIONS");
            this.$router.push({
              name: "Repondre",
              params: { urlparticipant: this.urlparticipant },
            });
          }
          // le gars s'est inscrit mais n'a pas terminé l'inventaire, on le remet à la question 1
          if (response.data.message === "reprendre") {
            this.$store.commit("UPDATE_PARTICIPANT", response.data.infos);
            this.$store.commit("INSIGHT_QUESTIONS");
            this.$router.push({
              name: "Repondre",
              params: { urlparticipant: this.urlparticipant },
            });
            this.$buefy.toast.open({
              type: "is-danger",
              message: this.$i18n.t("toast.insight_en_cours"),
            });
          }

          // le gars a fini de répondre a ce test
          if (response.data.message == "fini") {
            this.$buefy.toast.open({
              type: "is-danger",
              message: this.$i18n.t("toast.insight_deja_repondu_et_fini"),
            });
            this.$router.push({ name: "home" });
          }
        })
        .catch((error) => {
          this.errors.push(error);
          this.$buefy.toast.open({
            type: "is-danger",
            message: this.$i18n.t("toast.insight_invalide"),
          });
          this.$router.push({ name: "home" });
        });
    },
    confirmCGU() {
      this.$buefy.dialog.confirm({
        size: "is-small",
        title: this.$i18n.t("public.titrecgu"),
        message: this.$i18n.t("public.cgudetail"),
        cancelText: this.$i18n.t("button.annuler"),
        confirmText: this.$i18n.t("public.cgu"),
        onConfirm: () => (this.cgu = true),
      });
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    axios.defaults.headers.common["urlparticipant"] = this.urlparticipant;
    axios
      .get(process.env.VUE_APP_URL_SSO_API + "insight/checkurlparticipant")
      .then((response) => {
        /* if (
          response.data.open_at !== "1970-01-01 00:00:00" ||
          response.data.close_at !== "1970-01-01 00:00:00"
        ) {
          if (
            new Date(response.data.close_at.replace(" ", "T")) <= new Date()
          ) {
            this.$buefy.toast.open({
              type: "is-danger",
              message: this.$i18n.t("toast.insight_cloture"),
            });
            this.$router.push({ name: "home" });
          }
          if (
            new Date(response.data.open_at.replace(" ", "T")) >= new Date() ||
            new Date(response.data.close_at.replace(" ", "T")) <= new Date()
          ) {
            var d = new Date(response.data.close_at);
            this.programmed = {
              name: response.data.name,
              dateDebut: response.data.open_at,
              dateFin: new Date(d.setDate(d.getDate()))
                .toISOString()
                .split("T")[0],
              affichage: true,
            };
          }
        } */
        if (
          (response.data.open_at !== "1970-01-01 00:00:00" &&
            response.data.open_at !== null) ||
          (response.data.close_at !== "1970-01-01 00:00:00" &&
            response.data.close_at !== null)
        ) {
          if (
            response.data.open_at !== "1970-01-01 00:00:00" &&
            response.data.open_at !== null &&
            new Date(response.data.open_at.replace(" ", "T")) >= new Date()
          ) {
            this.$buefy.toast.open({
              type: "is-danger",
              message: this.$i18n.t("toast.insight_cloture"),
            });
            this.$router.push({ name: "home" });
          } else if (
            response.data.close_at !== "1970-01-01 00:00:00" &&
            response.data.close_at !== null &&
            new Date(response.data.close_at.replace(" ", "T")) <= new Date()
          ) {
            this.$buefy.toast.open({
              type: "is-danger",
              message: this.$i18n.t("toast.insight_cloture"),
            });
            this.$router.push({ name: "home" });
          }
        }

        this.insight_name = response.data.name;
        this.insight_id = response.data.id;
        if (response.data.media)
          this.background =
            "background-size: cover; background-image:url('" +
            this.url_insight +
            response.data.media +
            "')";
      })
      .catch((error) => {
        this.errors.push(error);
        this.$buefy.toast.open({
          type: "is-danger",
          message: this.$i18n.t("toast.insight_invalide"),
        });
        this.$router.push({ name: "home" });
      });
  },
};

function verifMail(mailVerif) {
  var myRegex = /^[A-Za-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,20}([A-Za-z0-9._-]+@[a-z0-9._-]+\.[a-z]{2,20}){0,4}$/;
  if (myRegex.test(mailVerif)) {
    return true;
  } else {
    return false;
  }
}
</script>

<style scoped>
.textit_background_home {
  background-size: cover;
}
.input {
  background: #eeeeee !important;
  border-radius: 0px;
  box-shadow: none;
  font-size: 12px;
}
.form_login {
  width: 400px;
  margin: 0px auto;
  background: white;
  padding: 40px;
  opacity: 0.95;
  border-radius: 10px;
  -moz-box-shadow: 0px 2px 8px 0px #656565;
  -webkit-box-shadow: 0px 2px 8px 0px #656565;
  -o-box-shadow: 0px 2px 8px 0px #656565;
  box-shadow: 0px 2px 8px 0px #656565;
  filter: progid:DXImageTransform.Microsoft.Shadow(color=#656565, Direction=180, Strength=8);
}

.cartouchePublic a {
  color: #f8df40;
}
.cartouchePublic {
  color: white;
  background: #424a60;
  text-align: left;
  height: 60px;
  padding: 5px;
  font-size: 1.5em;
  z-index: 1000;
  /*position: relative;*/
}

.cartouchePublic img {
  height: 45px;
  vertical-align: middle;
  margin-right: 10px;
}
</style>
